const UrlService = (function () {

  return {
    getBaseDomain,
    getUrlParam,
    hasUrlParam,
    addOrUpdateUrlParam,
    }

    function getBaseDomain() {
      return window.location.origin;
    }
    
    function getUrlParam(name) {
      var url = new URL(window.location.href);
    
      return url.searchParams.get(name);
    }
    
    function hasUrlParam(name) {
      var url = new URL(window.location.href);
    
      return url.searchParams.has(name);
    }
    
    function addOrUpdateUrlParam(name, value) {
      var url = new URL(window.location.href);
      url.searchParams.set(name, value);
    
      window.history.pushState({}, '', url);
    }

}());
